// @ts-nocheck
import clsx from "clsx";
import React, { HTMLAttributes, PropsWithChildren } from "react";

type BadgeCardProps = PropsWithChildren<{
  className?: string;
}> & HTMLAttributes<HTMLDivElement>;

export const BadgeCard: React.FC<BadgeCardProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <section
      className={clsx(
        className,
        "flex items-center w-full rounded-xl px-4 py-3 gap-2 border border-blue-200"
      )}
      {...rest}
    >
      {children}
    </section>
  );
};
